import { render, staticRenderFns } from "./NonUseFees.vue?vue&type=template&id=991b574a&scoped=true"
import script from "./NonUseFees.vue?vue&type=script&lang=js"
export * from "./NonUseFees.vue?vue&type=script&lang=js"
import style0 from "./NonUseFees.vue?vue&type=style&index=0&id=991b574a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991b574a",
  null
  
)

export default component.exports